import React from 'react';
import * as Formatting from 'fw/misc/Formatting'

class Currency extends React.Component {
	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

    render() {
        return <div style={{textAlign:'right'}}>{Formatting.formatCurrency(this.props.value)}</div>
    }
}

export default Currency;


// WEBPACK FOOTER //
// ./src/fw/components/formatter/Currency.js